import type { NewCoreIconProps } from '@atlaskit/icon/base-new';
import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyCalendarIcon: LoadableType<NewCoreIconProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CalendarIcon" */ '@atlaskit/icon/core/calendar'))
			.default,
});

export const LazyFeedbackIcon: LoadableType<NewCoreIconProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FeedbackIcon" */ '@atlaskit/icon/core/megaphone'))
			.default,
});
